import React, { useState } from "react";
import logo from "../Assets/Vector Smart Object.png";
import { Link } from "react-router-dom";
import airbnb from "../Assets/airbnb.png";
import bdot from "../Assets/B-dot.png";
import booking from "../Assets/booking.png";
import air from "../Assets/air.png";
import badge from "../Assets/badge.png";
import instagram from "../Assets/instagram.png";
import axios from "axios";
import toast from "react-hot-toast";

const NewFooter = () => {
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();

    const email = { email: e.target.email.value };
    try {
      setLoading(true);
      // Sending data to the backend
      const response = await axios.post(
        "https://365luxuryhomes.com/api/newsletter",
        email
      );

      if (response.status === 200) {
        toast.success("Thank you for subscribing!");
        setLoading(false);
        e.target.email.value = "";
      } else {
        toast.error("Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoading(false);
      toast.error("Error submitting form. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="bg-[#a9a7a3] text-white font-inter py-10">
      <footer className="container mx-auto px-4  md:py-16 py-10">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 md:gap-16 pb-8 border-b border-white">
          {/* Left Section (Logo & Address) */}
          <div className="flex flex-col items-start gap-4 flex-shrink-0">
            <img
              src={logo}
              alt="Company Logo"
              className="w-40 h-auto brightness-200"
            />
            <div className="flex items-start gap-2 text-white mt-4">
              {/* SVG for location pin */}
              <svg
                className="w-6 h-6 flex-shrink-0 mt-1"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"></path>
              </svg>
              <p className=" font-light">4TH STREET, AL QUOZ, DUBAI</p>
            </div>
            <div className="flex items-center gap-2">
              <span>FOLLOW US ON:</span>
              <a
                href="https://www.instagram.com/365luxuryhomes.dxb/reels/"
                className="hover:text-gray-700 transition"
                rel="noreferrer"
                target="_blank"
              >
                <img src={instagram} alt="" className="w-6" />
              </a>
            </div>
          </div>

          {/* Middle Section (Navigation) */}
          <div className="flex flex-row justify-around flex-grow gap-8 md:gap-16">
            <div>
              <span className=" text-white uppercase">Navigation</span>
              <ul className="space-y-2 text-sm md:text-base font-light list-disc pl-6 mt-2">
                <li className="">
                  <Link
                    to={"/"}
                    className="text-white hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    HOME
                  </Link>
                </li>
                <li className="">
                  <Link
                    to={"/about"}
                    className="text-white hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    ABOUT US
                  </Link>
                </li>
                <li className="">
                  <Link
                    to={"/experiences"}
                    className="text-white uppercase hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    Experiences
                  </Link>
                </li>
                <li className="">
                  <Link
                    to={"/properties"}
                    className="text-white hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    PROPERTIES
                  </Link>
                </li>
                <li className="">
                  <Link
                    to={"/contact"}
                    className="text-white hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    CONTACT US
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <span className=" text-white">HOLIDAY HOMES IN</span>
              <ul className="space-y-2 text-sm md:text-base font-light pl-6 mt-2">
                <li className="list-disc">
                  <Link
                    to={"/properties?#palm_jumeirah"}
                    className="text-white uppercase hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    Palm Jumeirah
                  </Link>
                </li>
                <li className="list-disc">
                  <Link
                    to={"/properties?#bluewaters_island"}
                    className="text-white uppercase hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    Bluewaters Island
                  </Link>
                </li>
                <li className="list-disc">
                  <Link
                    to={"/properties?#jbr"}
                    className="text-white uppercase hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    JBR
                  </Link>
                </li>
                <li className="list-disc">
                  <Link
                    to={"/properties?#downtown"}
                    className="text-white uppercase hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    Downtown
                  </Link>
                </li>
                <li className="list-disc">
                  <Link
                    to={"/properties?#dubai_marina"}
                    className="text-white uppercase hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    Dubai Marina
                  </Link>
                </li>
                <li className="list-disc">
                  <Link
                    to={"/properties?#ebf"}
                    className="text-white uppercase hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    Emaar Beachfront
                  </Link>
                </li>
                <li className="list-disc">
                  <Link
                    to={"/properties?#district_one"}
                    className="text-white uppercase hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    District One
                  </Link>
                </li>
                <li className="list-disc">
                  <Link
                    to={"/properties?#jvc"}
                    className="text-white uppercase hover:text-[#f1f1f1] active:text-[#f6f6f6] focus:text-[#f6f6f6]"
                  >
                    JVC
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Section (Newsletter & Social) */}
          <div className="flex flex-col items-start gap-4 md:w-auto w-full">
            <p className="font-light text-sm md:text-base">
              SUBSCRIBE TO OUR NEWSLETTER
            </p>
            <form onSubmit={handleSubmit} className="flex w-full">
              <input
                type="email"
                name="email"
                placeholder="Example@gmail.com"
                className="px-4 py-4 w-full text-sm rounded-l-md focus:outline-none focus:ring-2 focus:ring-gray-500 bg-gray-200 text-gray-800"
              />
              <button className="px-6 py-2 text-white text-sm rounded-r-md bg-[#63625f] hover:bg-gray-700 transition">
                {loading ? (
                  <span className="loading loading-spinner loading-md"></span>
                ) : (
                  "Subscribe"
                )}
              </button>
            </form>
            <p className="font-light text-sm md:text-base mt-2 flex items-center">
              <span>FIND US ON:</span>
              <div className="flex items-center gap-4 ml-4">
                <a href="#" className="hover:text-gray-700 transition">
                  <img src={bdot} alt="" className="w-6" />
                </a>
                <a href="#" className="hover:text-gray-700 transition">
                  <img src={air} alt="" className="w-6" />
                </a>
              </div>
            </p>
          </div>
        </div>

        {/* Middle Section (Reviews) */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 md:gap-16 py-8 border-b border-white">
          {/* Airbnb Review */}
          <div className="flex items-center md:gap-4 gap-2">
            <img src={airbnb} alt="" className="md:w-32 w-20" />
            <div className="w-[1px] h-32 bg-white"></div>
            <div className="flex flex-col text-[#fbfaed]">
              <p className="text-2xl font-semibold">365 Luxury Homes</p>
              <div className="flex items-center gap-2 mt-2">
                <img src={badge} alt="" className="md:w-6 w-4" />
                <p className="text-xl font-light">Superhost</p>
              </div>
              <div className="flex items-center md:gap-5 gap-2 text-xs font-light mt-2">
                <div className="flex flex-col">
                  <span className="md:text-2xl text-lg font-bold">379</span>
                  <span className="text-sm">Reviews</span>
                </div>
                <div className="w-[2px] h-8 bg-white"></div>
                <div className="flex flex-col">
                  <span className="font-bold md:text-2xl text-lg">4.94 ★</span>
                  <span className="text-sm">Rating</span>
                </div>
                <div className="w-[2px] h-8 bg-white"></div>
                <div className="flex flex-col">
                  <span className="md:text-2xl text-lg font-bold">4 </span>
                  <span className="text-sm">Years Hosting</span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-5">
            {/* Company Score */}
            <div className="flex items-center gap-4">
              <div className="flex flex-col text-[#fbfaed]">
                <p className="text-xl font-light">Company Review Score:</p>
                <p className="text-4xl md:text-4xl font-semibold mt-2">9.4 ★</p>
              </div>
            </div>
            <div className="w-[2px] h-20 bg-white"></div>
            {/* Booking.com Review */}
            <div className="flex items-center gap-4">
              <div className="flex flex-col">
                <img src={booking} alt="" className="w-40" />
                <p className="text-sm font-light mt-2">
                  Based on 445 Reviews <br /> from 29 properties
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section (Legal) */}
        <div className="flex md:flex-row flex-col gap-4 justify-between items-center pt-8 text-sm text-gray-600">
          <div className="flex gap-4">
            <Link
              to="/privacy-policy"
              className="text-white hover:text-white active:text-white focus:text-white hover:underline"
            >
              Privacy Policy
            </Link>
            <div className="w-[2px] h-4 bg-white"></div>
            <Link
              to="/terms-and-conditions"
              className="text-white hover:text-white active:text-white focus:text-white hover:underline"
            >
              Terms and Conditions
            </Link>
          </div>
          <p className="text-white">
            © 2025 365 Luxury Homes. All rights reserved
          </p>
        </div>
      </footer>
    </div>
  );
};

export default NewFooter;
